import React from 'react';
import PropTypes from 'prop-types';
import { ChevronRightIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import * as styles from './allhomes-listing-agents-link.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AgentsLink = props => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var text = "View real estate agents in ".concat(props.suburbName);
  return ___EmotionJSX("div", {
    css: styles.linkContainer
  }, ___EmotionJSX("a", {
    css: styles.link,
    href: props.linkUrl,
    onClick: () => sendEvent('view-agents-click', {
      elementText: text
    })
  }, ___EmotionJSX("span", {
    css: styles.text
  }, text), ___EmotionJSX(ChevronRightIcon, {
    size: "small"
  })));
};
AgentsLink.propTypes = {
  linkUrl: PropTypes.string,
  suburbName: PropTypes.string
};
AgentsLink.defaultProps = {
  linkUrl: '',
  suburbName: ''
};
export default AgentsLink;